import { render, staticRenderFns } from "./PointsStatement.vue?vue&type=template&id=65bc5d0d&"
import script from "./PointsStatement.vue?vue&type=script&lang=js&"
export * from "./PointsStatement.vue?vue&type=script&lang=js&"
import style0 from "./PointsStatement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PointsStatement.vue"
export default component.exports